"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundSwitchTracker = void 0;
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var mappings_1 = require("../../../../shared/api/mappings");
var core_1 = require("../../../../shared/core");
var Loading_1 = require("../../components/Loading");
var InboundSwitchTrackerKapiData_1 = require("./InboundSwitchTrackerKapiData");
var InboundSwitchTrackerLegacyData_1 = require("./InboundSwitchTrackerLegacyData");
var Error = function () {
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    return react_1.default.createElement(ErrorSection, { id: "api-error", "data-testid": "omr-api-error" });
};
var InboundSwitchTrackerKapi = function (_a) {
    var accountId = _a.accountId;
    var _b = (0, mappings_1.useMeterReads)(accountId), data = _b.data, loading = _b.loading, error = _b.error;
    if (error) {
        return react_1.default.createElement(Error, null);
    }
    if (loading || !data) {
        return react_1.default.createElement(Loading_1.Loading, null);
    }
    return react_1.default.createElement(InboundSwitchTrackerKapiData_1.InboundSwitchTrackerKapiData, { combinedSupplies: data });
};
var InboundSwitchTrackerLegacy = function (_a) {
    var accountId = _a.accountId;
    var _b = (0, legacy_queries_1.useSupplyPoints)(accountId), data = _b.data, loading = _b.loading, error = _b.error;
    var openingMeterReadingsQueryResult = (0, legacy_queries_1.useOpeningMeterReadingsLegacyQuery)(accountId);
    if (error || openingMeterReadingsQueryResult.status === 'error') {
        return react_1.default.createElement(Error, null);
    }
    if (loading ||
        openingMeterReadingsQueryResult.isFetching ||
        !data ||
        openingMeterReadingsQueryResult.status === 'no-data') {
        return react_1.default.createElement(Loading_1.Loading, null);
    }
    return (react_1.default.createElement(InboundSwitchTrackerLegacyData_1.InboundSwitchTrackerLegacyData, { supplyPoints: data, openingMeterReadings: openingMeterReadingsQueryResult.data }));
};
exports.InboundSwitchTracker = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var accountId = _a.accountId;
    var meterReads = core_1.configService.getConfig().meterReads;
    var kapiSwitchTracker = meterReads === null || meterReads === void 0 ? void 0 : meterReads.kapiOnly;
    return kapiSwitchTracker ? (react_1.default.createElement(InboundSwitchTrackerKapi, { accountId: accountId })) : (react_1.default.createElement(InboundSwitchTrackerLegacy, { accountId: accountId }));
}, Loading_1.Loading);
